import './v2.css';
import { ScrollProgressBar } from './ScrollProgressBar';
import { Navbar } from './Navbar';
import { Hero } from './Hero';
import { SolutionsSection } from './SolutionsSection';
import { TrustedBySection } from './TrustedBySection';
import { CtaSection } from './CtaSection';
import { WhyChooseSection } from './WhyChooseSection';
import { SecuritySection } from './SecuritySection';
import { InsightsSection } from './InsightsSection';
import { Footer } from './Footer';

export default function LandingPageV2() {
  return (
    <div style={{ background: '#fff' }}>
      <ScrollProgressBar />
      <Navbar />
      <Hero />
      <SolutionsSection />
      <TrustedBySection />
      <CtaSection />
      <WhyChooseSection />
      <SecuritySection />
      <InsightsSection />
      <Footer />
    </div>
  );
}
